<template>
  <div class="main">
    <div class="float-left" v-if="show4">

      <div class="float-left pa-3" />

      <template v-if="share">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="handleShare"
              class="mx-2 float-left"
              fab
              outlined
              dark
              small
              color="#424242"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>
                mdi-share-off
              </v-icon>
            </v-btn>
          </template>
          <span>parar de compartilhar</span>
        </v-tooltip>

        <div class="card float-left ml-1 px-4 py-1-2 ">
          <a :href="link" target="_blank" class="link text-caption"> {{ link.slice(0, 40) }}...</a>
          <v-icon
            class="ml-3 mb-1 cursor"
            size="small"
            v-clipboard:copy="`${link}`"
            @click="copyURL"
          >
            {{ copy ? "mdi-check-bold" : "mdi-content-copy" }}
          </v-icon>
        </div>
      </template>
      <template v-else>
        <v-btn
          @click="handleShare"
          rounded
          color="#42424299"
          outlined
          class="text-capitalize"
        >
          <v-icon class="mr-2">mdi-share</v-icon>compartilhar</v-btn
        >
      </template>
    </div>
    <div class="float-right">
      <v-btn
        @click="action2"
        rounded
        color="primary"
        class="text-capitalize"
        v-if="show2"
        >publicar
        <v-icon class="ml-2" size="small">mdi-earth</v-icon></v-btn
      >
      <v-btn
        @click="action1"
        rounded
        color="primary"
        class="ml-3 text-capitalize"
        >editar no simulador
        <v-icon class="ml-2" size="small"
          >mdi-square-edit-outline</v-icon
        ></v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "HandlePlanMenu",
  props: {
    share: Boolean,
    hash: String
  },
  data() {
    return {
      copy: false,
      link: ""
    };
  },
  methods: {
    action1() {
      this.$emit("action1");
    },
    action2() {
      this.$emit("action2");
    },
    handleShare() {
      this.$emit("share");
    },
    copyURL() {
      this.copy = true;
      setTimeout(() => {
        this.copy = false;
      }, 3000);
    }
  },
  mounted() {
    this.link = origin + `/paas/temp/${this.hash}`;
    console.log(this.link);
  },
  computed: {
    show2() {
      return this.$store.getters.getAllow(3);
    },
    show4() {
      return this.$store.getters.getAllow(4);
    }
    // link() {
    //   return this.$router.resolve({
    //     path: `paas/temp/${this.hash}`
    //   }).href;
    // }
  }
};
</script>

<style scoped>
.main {
  display: table;
  width: 100%;
}

.card {
  border: 1px solid #424242;
  border-radius: 30px;
}

.py-1-2 {
  padding-top: 6px;
  padding-bottom: 6px;
}
</style>
